<div class="recherche-instagram-artiste">
  <form class="search-form">
    <mat-form-field class="search-full-width">
      <mat-label>Recherche Instagram artiste</mat-label>
      <input #searchInput matInput placeholder="Recherche Instagram artiste" value="" (keydown.enter)="searchArtistInstagramEnter($event, searchInput.value)" >
      <button mat-button *ngIf="searchInput.value" matSuffix aria-label="Clear" (click)="searchInput.value=''">
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </mat-form-field>
  </form>
  <button color="primary" class="search-full-width-button" mat-flat-button (click)="searchArtistInstagram(searchInput.value)">Recherche</button>
</div>

<div class="searchResults">
  <mat-progress-spinner *ngIf="loading" class="mat-progress-spinner-coverSearch" mode="indeterminate"></mat-progress-spinner>

  <div class="noResults" *ngIf="!loading && musicbrainzResults.length === 0 && geniusResults.length === 0">
    Aucun résultat.
    <a class="instagram-manual-search" href="https://www.instagram.com/explore" target="_blank" rel="noopener">
      Rechercher sur Instagram
    </a>
  </div>

  <div class="instagram-candidate" *ngFor="let result of musicbrainzResults" (click)="selectInstagram(result.instagram)">
    <span class="instagram-handle">{{ result.instagram }}</span>
    <span class="instagram-name">{{ result.name }}<ng-container *ngIf="result.disambiguation"> ({{ result.disambiguation }})</ng-container> — MusicBrainz</span>
    <a class="instagram-verify-link" [href]="instagramProfileUrl(result.instagram)" target="_blank" rel="noopener"
       (click)="$event.stopPropagation()" matTooltip="Ouvrir le profil pour vérifier">Vérifier</a>
  </div>

  <div class="instagram-candidate" *ngFor="let result of geniusResults" (click)="selectInstagram(result.instagram)">
    <img *ngIf="result.image" [src]="result.image" class="instagram-candidate-image" />
    <span class="instagram-handle">{{ result.instagram }}</span>
    <span class="instagram-name">{{ result.name }} — Genius</span>
    <a class="instagram-verify-link" [href]="instagramProfileUrl(result.instagram)" target="_blank" rel="noopener"
       (click)="$event.stopPropagation()" matTooltip="Ouvrir le profil pour vérifier">Vérifier</a>
  </div>
</div>
